<template>
  <div class="main">
    <h2 class="conTitle">{{title}}</h2>
    <ul class="aboutNav">
      <li><a href="#aboutIntro">自我介绍</a></li>
      <li><a href="#aboutSkill">专业技能</a></li>
      <li><a href="#aboutWork">工作经历</a></li>
      <li><a href="#aboutProject">我的项目</a></li>
      <li><a href="#aboutTime">时光机</a></li>
      <li><a href="#aboutContact">联系我</a></li>
    </ul>

    <div class="aboutCon">
      <h3 id="aboutIntro" class="abNavItem">自我介绍</h3>
      <p>{{blogInfo.about.PersonalInfo.intro}}</p>
      <ul>
        <li v-for="item in blogInfo.about.PersonalInfo.introList">{{item}}</li>
      </ul>
      <h3 id="aboutSkill" class="abNavItem">专业技能</h3>
      <ul>
        <li v-for="item in blogInfo.about.DesirableSkills">{{item}}</li>
      </ul>
      <h3 id="aboutWork" class="abNavItem">工作经历</h3>
      <ul>
        <tbody>
        <tr v-for="item in blogInfo.about.WorkExperience">
          <td>{{item.name}}</td>
          <td>&emsp;|&emsp;{{item.time}}</td>
          <td>&emsp;|&emsp;{{item.job}}</td>
        </tr>
        </tbody>
      </ul>
      <h3 id="aboutProject" class="abNavItem">我的项目</h3>
      <ul>
        <li v-for="item in blogInfo.about.ProjectExperience">
          <a :class="!item.url?'noJump':''" target="_blank" :href="item.url?item.url:'javascript:;'">{{item.name}}</a>
        </li>
      </ul>
      <h3 id="aboutTime" class="abNavItem">时光机</h3>
      <p>博客已运行：{{blogTime}}</p>
      <h3 id="aboutContact" class="abNavItem">联系我</h3>
      <ul>
        <li v-for="item in blogInfo.about.PersonalInfo.contact" v-html="item"></li>
      </ul>
    </div>

    <!--<el-button type="primary">主要按钮</el-button>-->
  </div>
</template>

<script>
  export default {
    name: 'about',
    data() {
      return {
        title: '关于',
        blogInfo:this.$store.state.blogInfo,
        blogTime:'',
        timeInterval:function () {}
      }
    },
    components: {},
    mounted: function () {
      window.document.title = '关于 - 小桃酥的曲奇饼';
      let _that= this;
      this.timeInterval=setInterval(function () {
        let newTime = new Date(), nowTime = new Date(_that.blogInfo.createTime), day, hour, minute, second;
        let spanTimer = newTime - nowTime;
        day = Math.floor(spanTimer / 86400000);
        spanTimer -= day * 86400000;
        hour = Math.floor(spanTimer / 3600000);
        spanTimer -= hour * 3600000;
        minute = Math.floor(spanTimer / 60000);
        spanTimer -= minute * 60000;
        second = Math.floor(spanTimer / 1000);
        _that.blogTime = day + '天' + hour + '时' + minute + '分' + second + '秒'
      }, 1000)
    },
    beforeDestroy:function () {
      window.clearInterval(this.timeInterval)
    }
  }
</script>
<style lang="scss">
  .main {
    margin-bottom: 50px;
    .conTitle {
      font-size: 32px;
      margin-bottom: 25px;
      font-weight: 300;
    }
    .aboutNav {
      margin-left: 20px;
      li {
        list-style: disc;
        margin: 10px 0;
        a {
          color: #0088cc;
        }

      }
    }
    .aboutCon {
      .abNavItem {
        font-size: 24px;
        color: #666;
        font-weight: bold;
        margin: 20px 0;
      }
      p{
        margin: 15px 0;
      }
      ul{
        max-width: 1035px;
        margin-left: 20px;
        li{
          list-style: disc;
          margin: 5px 0;
          span{
            font-weight: bold;
          }
          a{
            color: #0088cc;
          }
        }
      }
      .noJump{
        cursor: default;
        color: #000;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/about.vue